import ArchStandaloneSectionComponent from "@/template/blocks/ArchStandaloneSection/component";
import * as S from "./styles";
import { IImageProps } from "@/lib/types/components";
import Image from "next/image";
import { DynamicIcon, P } from "@/template/components";
import Button, { IButtonProps } from "@/template/components/Button";

const BasicSection = ({
  altStyling,
  basicBlock,
}: {
  altStyling?: boolean;
  greyBackground?: boolean;
  basicBlock?: {
    heading?: string;
    image?: IImageProps;
    isParagraph?: boolean;
    content?: string;
    backgroundColor?: "grey" | "burgundy" | "white";
    buttons?: ({
      label: string;
      link: string;
      variant: "outline" | "flat" | "solid" | "light";
      target?: "_blank";
    } & Partial<IButtonProps>)[];
    bullets?: { text: string }[];
    flip?: boolean;
  };
}) => {
  return (
    <S.HeroFooterImageContainer $altStyling={altStyling}>
      {altStyling && (
        <ArchStandaloneSectionComponent
          color="white"
          background={"dark"}
          withPadding={true}
          style={{
            position: "absolute",
            top: "29%",
            left: 0,
            right: 0,
            zIndex: 1,
          }}
        />
      )}
      <S.Container
        $imagePosition={basicBlock?.flip}
        $backgroundColor={basicBlock?.backgroundColor}
      >
        <S.ImageWrapper>
          <Image
            src={basicBlock?.image?.src || ""}
            alt={basicBlock?.image?.alt || ""}
            height={576}
            width={650}
            style={{ objectFit: "contain" }}
          />
        </S.ImageWrapper>
        <S.TextWrapper>
          <S.Title>{basicBlock?.heading}</S.Title>
          {basicBlock?.isParagraph ? (
            <P>{basicBlock?.content}</P>
          ) : (
            <S.BulletList>
              {basicBlock?.bullets.map((bullet, index) => (
                <S.BulletItem key={index}>
                  <DynamicIcon name={"CheckedCircle"} />
                  <S.BulletText>{bullet.text}</S.BulletText>
                </S.BulletItem>
              ))}
            </S.BulletList>
          )}
          {basicBlock?.buttons && basicBlock?.buttons?.length ? (
            <S.ButtonGroup>
              {(basicBlock?.buttons as any).map(
                (
                  { variant, target, link, label, children, key, ...props },
                  index: number
                ) => (
                  <Button
                    key={index}
                    variant={variant}
                    size="lg"
                    {...props}
                    navigation={{
                      target,
                      href: link,
                    }}
                  >
                    {children || label}
                  </Button>
                )
              )}
            </S.ButtonGroup>
          ) : null}
        </S.TextWrapper>
      </S.Container>
    </S.HeroFooterImageContainer>
  );
};

export default BasicSection;
